import React from 'react'
import './Thirdsection.css'
function Thirdsection() {
  return (
    <>
      <div className="third" data-aos="fade-up">
        <div className="animationsec">
      <h1 className="animate">ANIMATE ANYTHING</h1>
        {/* <div className="anim">
  <div className="circle"></div>
  <div className="circle"></div>
  <div className="circle"></div> 
  </div>  */}
  <div className="animated-text">
    CSS-LAB <br /><span> </span>
    </div>
        </div>
        <div className="infotextthird">
          <p>Animated anything with just a few lines of code.CSS templates are pre-designed stylesheets used to quickly and easily customize the appearance of websites. They offer varied layouts, color schemes, and design elements for efficient web development.They offer varied layouts, color schemes, and design elements for efficient web development.</p>
        </div>
      </div>
    </>
  )
}
 
export default Thirdsection
